<studio-button-legacy
  *ngIf="videoControls.ready$ | async"
  isIconOnly="true"
  theme="dark-secondary"
  (click)="clicked()"
>
  <studio-icon [name]="isPaused ? 'play' : 'pause'"></studio-icon>
</studio-button-legacy>
